/**
 * Module-singleton for the in-memory `File` an anonymous visitor
 * dropped into the homepage hero. The `File` object isn't
 * serialisable, so it can't live in Redux — but the rest of the
 * anonymous selection (filename, dimensions, thumbnail object-URL)
 * does live in `artworkSlice.selectedArtwork`.
 *
 * When the visitor signs in (login fulfilled), the `promoteAnonymousArtwork`
 * thunk reads this singleton, uploads the file, and replaces the
 * anonymous selection with a persisted one. If the singleton is empty
 * (file already promoted, or visitor never uploaded one), the thunk
 * is a no-op.
 *
 * Lifetime: lives only in the current tab; gone on refresh, which is
 * fine because the anonymous selection itself doesn't survive a
 * refresh either (the blob URL is unrecoverable). See `SelectedArtwork`
 * for the broader Survival contract.
 *
 * SH-ARTWORK-001 follow-up.
 */

let pendingFile: File | null = null;

export function setPendingArtworkFile(file: File | null): void {
  pendingFile = file;
}

export function readPendingArtworkFile(): File | null {
  return pendingFile;
}

export function clearPendingArtworkFile(): void {
  pendingFile = null;
}
